import React, { useCallback, useEffect, useState } from "react";
import Logo from "../../assets/images/WeRentt-final-logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faBars,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import userIcon from "../../assets/images/icons/user-info.png";
import wishlistIcon from "../../assets/images/icons/wishlist-menu.png";
import assignedPropIcon from "../../assets/images/icons/assigned-property-menu.png";
import revenue from "../../assets/images/icons/revenue.png";
import billsIcon from "../../assets/images/icons/bills-menu.png";
import supportMenuIcon from "../../assets/images/icons/support-menu.png";
import feedbackIcon from "../../assets/images/icons/reviews-menu.png";
import Cookies from "js-cookie";
import { useUser } from "../context/UserContext";
import { Sidebar } from "primereact/sidebar";
import { clearAuthTokens } from "../../utils/authTokens";

import information from "../../assets/images/icons/information.png";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, setAuthentication } = useUser();

  const [navSidebar, setNavSidebar] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const checkLoginStatus = useCallback(() => {
    const accessToken = Cookies.get("accessToken");
    if (accessToken) {
      setAuthentication(!!accessToken);
    } else {
      setAuthentication(null);
    }
  }, []);
  useEffect(() => {
    checkLoginStatus();
  }, [checkLoginStatus]);
  const handleLogout = () => {
    clearAuthTokens();
    setAuthentication(null);
    navigate("/");
    window.location.reload();
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // -home remove from the class

  const isHomePage = location.pathname === "/";
  const headerClass = `header ${isScrolled ? "header-fix" : ""} ${
    isHomePage ? "header" : ""
  }`;
  return (
    <>
      <header className={headerClass}>
        {/* <section className="sliding-strip">
          <div className="marquee-content-wrap">
            <p>
              We are pleased to announce rebranding of{" "}
              <Link to={"#"}>werentt.com</Link> to{" "}
              <Link to={"#"}>werentt.com</Link> (reflecting, what we do). The
              rebranding process will commence from 11 June, 2025. This
              rebranding reflects our renewed commitment to delivering a
              seamless and innovative rental experience. While our name has
              changed, our dedication to excellence remains stronger than ever.
              Welcome to the next chapter of renting with #WeRentt.
            </p>
            <p>
              We are pleased to announce rebranding of{" "}
              <Link to={"#"}>werentt.com</Link> to{" "}
              <Link to={"#"}>werentt.com</Link> (reflecting, what we do). The
              rebranding process will commence from 11 June, 2025. This
              rebranding reflects our renewed commitment to delivering a
              seamless and innovative rental experience. While our name has
              changed, our dedication to excellence remains stronger than ever.
              Welcome to the next chapter of renting with #WeRentt.
            </p>
            <p>
              We are pleased to announce rebranding of{" "}
              <Link to={"#"}>werentt.com</Link> to{" "}
              <Link to={"#"}>werentt.com</Link> (reflecting, what we do). The
              rebranding process will commence from 11 June, 2025. This
              rebranding reflects our renewed commitment to delivering a
              seamless and innovative rental experience. While our name has
              changed, our dedication to excellence remains stronger than ever.
              Welcome to the next chapter of renting with #WeRentt.
            </p>
          </div>
        </section> */}
        <div className="container">
          <nav className="navbar navbar-expand-lg header-nav">
            <div className="header-nav-wrap">
              <div className="navbar-header ">
                <Link to="/" className="navbar-brand logo">
                  <img src={Logo} className="img-fluid" alt="Logo" />
                </Link>
              </div>
              <ul
                className={`nav header-navbar-rht nav-middle-menu ${
                  user?.isAuthenticated ? "logged-in" : "logged-out"
                }`}
              >
                {/* {!user?.isAuthenticated && ( */}
                <>
                  <li>
                    <Link to={"/"}>Rent</Link>
                  </li>
                  <li className="nav-item-with-badge">
                    <Link to={"buy"}>
                      Buy
                      <span className="nav-new-badge">New</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"sell"}>Sell</Link>
                  </li>
                  <li>
                    <Link to={"buy/list?listingType=new"}>New Project</Link>
                  </li>
                  <li className="tools-nav-item">
                    <span className="tools-nav-toggle">
                      Tools & Insights
                      <FontAwesomeIcon
                        icon={faChevronDown}
                        className="tools-arrow-icon"
                      />
                    </span>

                    <ul className="tools-dropdown-menu">
                      <li className="me-0">
                        <Link to="mortgage-calculator" className="me-0">
                          Mortgage Calculator
                        </Link>
                      </li>
                      <li className="me-0">
                        <Link to="buy-vs-rent" className="me-0">
                          Buy vs Rent
                        </Link>
                      </li>
                      {/* <li className="me-0">
                        <Link to="survey" className="me-0">
                          Home Buyer Survey
                        </Link>
                      </li> */}
                    </ul>
                  </li>
                  <li>
                    <Link to={"why-werentt"}>Why Werentt</Link>
                  </li>
                </>
                {/* )} */}
              </ul>
              <ul
                className={`nav header-navbar-rht  ${
                  user?.isAuthenticated ? "logged-in" : "logged-out"
                }`}
              >
                {/* //below are removed because  of new nav-bar Design */}
                {!user?.isAuthenticated && (
                  <>
                    {/* <li>
                      <Link to={"about-us"}>About Us</Link>
                    </li> */}
                    {/* <li>
                      <Link to={"contact-us"}>Contact Us</Link>
                    </li>
                    <li>
                      <Link to={"faq"}>Faqs</Link>
                    </li> */}

                    {/* <li>
                      <Link to={"buy"}>Buy</Link>
                    </li>
                    <li>
                      <Link to={"/"}>Rent</Link>
                    </li> 
                    <li>
                      <Link to={"sell"}>Sell</Link>
                    </li> 
                     <li>
                      <Link to={"buy/list?listingType=new"}>New Project</Link>
                    </li>  */}
                  </>
                )}
                <li className="new-property-btn">
                  {!user?.isAuthenticated ? (
                    <Link to="list-your-property" className="mob-none">
                      <span className="own-prop">Own a property ?</span> List
                      your property
                    </Link>
                  ) : (
                    <Link>
                      {/* <span className="own-prop">Welcome!</span> */}
                      <span style={{ color: "green", paddingRight: "4px" }}>
                        Welcome!{" "}
                      </span>{" "}
                      {user?.userInfo?.firstName}
                    </Link>
                  )}
                </li>
                {!user?.isAuthenticated && (
                  <li>
                    <Link to="/login" className="btn btn-primary">
                      Login
                    </Link>
                  </li>
                )}
                <li className="swr-menu">
                  <div
                    className="menu-icon"
                    onClick={() => setNavSidebar(true)}
                  >
                    <FontAwesomeIcon icon={faBars} />
                  </div>
                  <Sidebar
                    visible={navSidebar}
                    position="right"
                    onHide={() => setNavSidebar(false)}
                    className="nav-sidebar"
                  >
                    <div className="sidebar-top-menu-wrap">
                      <div
                        className="wrap"
                        onClick={() => setNavSidebar(false)}
                      >
                        {user?.isAuthenticated &&
                          user?.userRole === "Owner" && (
                            <ul className="swr-user-menu">
                              <li>
                                <Link to="owner-account/properties">
                                  <img src={assignedPropIcon} alt="icon" /> My
                                  Properties
                                </Link>
                              </li>

                              <li>
                                <Link to="owner-account/photos">
                                  <img src={wishlistIcon} alt="icon" /> Photos
                                </Link>
                              </li>
                              <li>
                                <Link to="owner-account/my-expenses">
                                  <img src={assignedPropIcon} alt="icon" />
                                  My Expenses
                                </Link>
                              </li>
                              <li>
                                <Link to="owner-account/revenue">
                                  <img src={revenue} alt="icon" />
                                  Revenue
                                </Link>
                              </li>
                              <li>
                                <Link to="owner-account/owner-bank-details">
                                  <img src={information} alt="icon" />
                                  Bank Details
                                </Link>
                              </li>
                              <li>
                                <Link to="owner-account/owner-profile-docs">
                                  <img src={feedbackIcon} alt="icon" />
                                  Documents
                                </Link>
                              </li>

                              <li>
                                <Link to="owner-account/ownerprofile">
                                  <img src={userIcon} alt="icon" />
                                  My Profile
                                </Link>
                              </li>
                            </ul>
                          )}
                        {user?.isAuthenticated &&
                          user?.userRole !== "Owner" && (
                            <ul className="swr-user-menu">
                              <li>
                                <Link to="my-account/profile">
                                  <img src={userIcon} alt="icon" /> My Profile
                                </Link>
                              </li>
                              <li>
                                <Link to="my-account/wishlist">
                                  <img src={wishlistIcon} alt="icon" /> Wishlist
                                </Link>
                              </li>
                              <li>
                                <Link to="my-account/assigned-property">
                                  <img src={assignedPropIcon} alt="icon" />
                                  Assigned Property
                                </Link>
                              </li>
                              <li>
                                <Link to="my-account/bills-payments">
                                  <img src={billsIcon} alt="icon" />
                                  Bills & Payments Info
                                </Link>
                              </li>
                              <li>
                                <Link to="my-account/support-request">
                                  <img src={supportMenuIcon} alt="icon" />
                                  Support
                                </Link>
                              </li>
                              <li>
                                <Link to="my-account/feedback">
                                  <img src={feedbackIcon} alt="icon" />
                                  Feedback
                                </Link>
                              </li>
                            </ul>
                          )}
                        <ul className="ser-main-menu">
                          <li>
                            <Link to="/">Rent</Link>
                          </li>
                          <li className="nav-item-with-badge">
                            <Link to="buy">
                              Buy
                              {/* <span className="nav-new-badge">New</span> */}
                            </Link>
                          </li>
                          <li>
                            <Link to="sell">Sell</Link>
                          </li>

                          <li>
                            <Link to="about-us">About</Link>
                          </li>
                          <li>
                            <Link to="why-werentt">Why Werentt</Link>
                          </li>
                          <li>
                            <Link to="blogs">Blogs</Link>
                          </li>
                          <li>
                            <Link to="faq">Faq</Link>
                          </li>
                          <li className="me-0">
                            <Link to="mortgage-calculator" className="me-0">
                              Mortgage Calculator
                            </Link>
                          </li>
                          <li className="me-0">
                            <Link to="buy-vs-rent" className="me-0">
                              Buy vs Rent Calculator
                            </Link>
                          </li>
                          {/* <li>
                            <Link to="survey">Home Buyer Survey</Link>
                          </li> */}
                          <li>
                            <Link to="terms-conditions">
                              Terms &amp; Conditions
                            </Link>
                          </li>
                          <li>
                            <Link to="privacy-policy">Privacy Policy</Link>
                          </li>
                          <li>
                            <Link to="cancellation-policy">
                              Cancellation Policy
                            </Link>
                          </li>
                          <li>
                            <Link to="contact-us">Contact Us</Link>
                          </li>
                        </ul>
                      </div>
                      <div
                        className="wrap"
                        onClick={() => setNavSidebar(false)}
                      >
                        {!user?.isAuthenticated && (
                          <Link to="/ownerlogin" className="btn btn-primary">
                            Owner Login
                          </Link>
                        )}
                      </div>
                      {user?.isAuthenticated && (
                        <div className="logout-btn">
                          <Button onClick={handleLogout}>Logout</Button>
                        </div>
                      )}
                    </div>
                  </Sidebar>
                </li>
              </ul>
            </div>
          </nav>
        </div>
        {!user?.isAuthenticated && (
          <div className="mobile-strip mob-show">
            <Link to="list-your-property">
              <span className="own-prop">Own a property ?</span> List a property{" "}
              <FontAwesomeIcon icon={faArrowRight} />
            </Link>
          </div>
        )}
      </header>
    </>
  );
};
export default Header;
